import { MatxLayoutSettings } from "app/components/MatxLayout/settings";
import { merge } from "lodash";
import { createContext, useState } from "react";

const STORAGE_KEY = "matx_active_theme";

const SettingsContext = createContext({
  settings: MatxLayoutSettings,
  updateSettings: () => {},
});

const getInitialSettings = (settings) => {
  if (settings) return settings;
  if (typeof localStorage !== "undefined") {
    const persisted = localStorage.getItem(STORAGE_KEY);
    if (persisted) {
      return merge({}, MatxLayoutSettings, { activeTheme: persisted });
    }
  }
  return MatxLayoutSettings;
};

export const SettingsProvider = ({ settings, children }) => {
  const [currentSettings, setCurrentSettings] = useState(
    getInitialSettings(settings)
  );

  const handleUpdateSettings = (update = {}) => {
    const marged = merge({}, currentSettings, update);
    setCurrentSettings(marged);
    if (update.activeTheme) {
      try {
        localStorage.setItem(STORAGE_KEY, update.activeTheme);
      } catch (e) {
        /* ignore */
      }
    }
  };

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        updateSettings: handleUpdateSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
